import { ReactElement } from "react";

import { Card } from "primereact/card";
import { classNames } from "primereact/utils";

const features = [
    { name: "Corporation", freeform: true, form15620: true },
    { name: "Public benefit corporation", freeform: true, form15620: true },
    { name: "Limited liability company", freeform: false, form15620: true },
    { name: "Limited partnership", freeform: false, form15620: true },
    { name: "Other entity types", freeform: false, form15620: true },
    { name: "Restricted Stock", freeform: true, form15620: true },
    { name: "Early exercised stock options", freeform: false, form15620: true },
    { name: "Profits Interests", freeform: false, form15620: true },
    { name: "Tokens", freeform: false, form15620: true },
    { name: "Other equity types", freeform: false, form15620: true },
];

function ComparisonTable(): ReactElement {
    return (
        <Card title="Form Comparison">
            <table className="w-full" style={{ borderCollapse: "collapse", tableLayout: "auto" }} >
                <thead>
                    <tr className="border-bottom-1 surface-border">
                        <th className="text-lg text-left py-3 px-4 font-medium text-color">Entity or Equity Type</th>
                        <th className="text-lg text-center py-3 px-4 font-medium text-color">
                            Freeform Statement
                        </th>
                        <th className="text-lg text-center py-3 px-4 font-medium text-color">Form 15620</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        features.map((feature, index) => {
                            return (
                                <tr key={index} className={classNames("border-bottom-1 surface-border", {"bg-gray-50": index % 2 === 0 })}>
                                    <td className="py-3 px-4 text-lg font-normal text-color">{feature.name}</td>
                                    <td className="py-3 px-4 text-center">
                                        <i className={classNames("pi font-semibold",{
                                            "pi-check text-green-600":feature.freeform,
                                            "pi-times text-red-600":!feature.freeform
                                        })}/>
                                    </td>
                                    <td className="py-3 px-4 text-center">
                                        <i className={classNames("pi font-semibold",{
                                            "pi-check text-green-600":feature.form15620,
                                            "pi-times text-red-600":!feature.form15620
                                        })}/>
                                    </td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </Card>

    )
}
export default ComparisonTable;